import type { OfertaTrabajoModel, StrapiResponseModel } from '@/interfaces/model';
import type { OfertaTrabajo, StrapiListResponse } from '@/interfaces/strapi';

export const ofertaTrabajoMapper = (c: OfertaTrabajoModel): OfertaTrabajo => ({
	id: c.documentId,
	titulo: c.titulo,
	ref: c.referencia,
	funciones: c.funciones,
	descripcion: c.descripcionPuesto,
	lugar: c.lugar,
	duracionContrato: c.duracionContrato,
	horario: c.horario,
	incorporacion: c.incorporacion,
	requisitos_exp: c.requisitosExperiencia,
	requisitos_form: c.requisitosFormacion,
	requisitos_otros: c.requisitosOtros,
});

export const ofertasTrabajoListMapper = (
	res: StrapiResponseModel<OfertaTrabajoModel>,
): StrapiListResponse<OfertaTrabajo> => {
	const list = (res.data ?? []).map(ofertaTrabajoMapper);

	const pagination = res.meta?.pagination ?? {
		page: 1,
		pageSize: list.length,
		pageCount: 1,
		total: list.length,
	};

	return { list, pagination };
};
